import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureAmplify } from './services/auth';
import App from './App';

// Initialize Amplify before rendering
configureAmplify();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
